import React, { Component, createRef } from "react";
import Header from "../After_Login_common/Header";
import Left_Sidebar from "../After_Login_common/Left_Sidebar";
import { userService } from "../../_services";
import { Redirect } from "react-router-dom";
//import CardPartial from './cardPartial';
import { jsPDF } from 'jspdf'
import domtoimage from 'dom-to-image';
import $ from 'jquery';
import OrderPage from "../Admin/Users/OrderPage";
//import PaymentForm from "../PaymentForm";
//import UpdatedTerms from "../Register/UpdatedTerms";
import CardFront from "../Summary/CardFront";
import CardBack from "../Summary/CardBack";
import FlyerPage1 from "./flyer1";
import FlyerPage2 from "./flyer2";
import FlyerLeft from '../../images/FlyerLeft.png'
import FlyerRight from '../../images/FlyerRight.png'
import closeIcon from '../../images/close.png';
import pdf1 from '../../resources/pricing-sheets/NuLifeSpan.Top.50.Walgreens.Mar25.pdf';
import pdf2 from '../../resources/pricing-sheets/NuLifeSpan.Top.CVS.Mar.25.pdf';
import pdf3 from '../../resources/pricing-sheets/NuLifeSpan.Walmart.top.Mar.25.pdf';

class OrderCardsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            UserData: [],
            shortname: '',
            fullName: '',
            account_info: '',
            group_numbers: [],
            group_status: '',
            GroupData: '',
            selected_group: '',
            isPrimary: '',
            show_Payment_popup: false,
            show_Userdetail_popup: false,
            errorMsg: '',
            zoomRight: false,
            zoomLeft: false,
            pricingSheetData: []
        }
        this.iframeRefs = {
            pdf1: createRef(),
            pdf2: createRef(),
            pdf3: createRef(),
        }
        this.flyer1Ref = createRef();
        this.flyer2Ref = createRef();
        this.printAll = this.printAll.bind(this);
        this.downloaddocall = this.downloaddocall.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.toggle_user_detail = this.toggle_user_detail.bind(this);
        this.updateGroup = this.updateGroup.bind(this);
        this.selectedGroupData = this.selectedGroupData.bind(this)
        this.printIndivisual = this.printIndivisual.bind(this);
        this.downloaddoc = this.downloaddoc.bind(this);
    }

    componentDidMount() {
        try {
            let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            let usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
            this.setState({ shortname: usernamedata.split(':')[0], fullName: usernamedata.split(':')[1] });
            let userinfo = window.atob(localStorage.getItem('_file_info'));
            this.setState({ account_info: userinfo });
            this.GetUserGroups(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            //this.GetUserCardSetting(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            document.addEventListener('click', this.handleOutsideClick);
            document.addEventListener('keydown', this.handleKeyDown);
            this.getPricingSheets(Usermeta_Data.split(':')[0]);
            //const cardsData = this.getCardsData();
            //this.setState({ cardsData });
        }
        catch {
            this.logout();
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    toggle_user_detail = (e) => {
        $('body').removeClass('payment-popup-active');
        e.stopPropagation();
        this.setState({ show_Userdetail_popup: !this.state.show_Userdetail_popup });
        this.setState({ show_Payment_popup: !this.state.show_Payment_popup });
    }

    handleClick = (e) => {
        this.setState({ show_Payment_popup: true });
        $('body').addClass('payment-popup-active');
    }
    // Convert all <canvas> elements inside a container to <img> tags so they
    // survive HTML serialisation (outerHTML strips canvas pixel data).
    replaceCanvasesWithImages(container) {
        container.querySelectorAll('canvas').forEach(canvas => {
            const img = document.createElement('img');
            img.src = canvas.toDataURL('image/png');
            img.style.cssText = canvas.style.cssText;
            canvas.parentNode.replaceChild(img, canvas);
        });
    }

    async printAll(event) {
        // Build a print-ready DOM: convert every canvas → <img> so pixel data is
        // preserved, and wrap each card at a fixed 700px width so they're never
        // constrained by the live-page CSS (max-width: 50% etc.).

        // Show printFlyers so flyer refs are in a rendered state for composeCanvas()
        $('.printFlyers').css('display', 'block');
        await new Promise((res) => requestAnimationFrame(res));

        const printPage = document.createElement('div');
        printPage.style.cssText = 'font-family: sans-serif;';

        // --- Card sections ---
        document.querySelectorAll('.order_card_wrapper.cards').forEach((cardEl) => {
            const section = document.createElement('div');
            section.style.cssText = 'page-break-after: always; padding: 30px 0; display:flex; flex-direction:column; align-items:center;';

            const wrap = document.createElement('div');
            wrap.style.cssText = 'display:flex;flex-direction:column;gap:20px;width:480px;max-width:100%;';

            const frontCanvas = cardEl.querySelector('canvas');
            const backImgEl = cardEl.querySelector('img');

            if (frontCanvas) {
                const img = document.createElement('img');
                img.src = frontCanvas.toDataURL('image/png');
                img.style.cssText = 'width:100%;height:auto;border-radius:16px;display:block;';
                wrap.appendChild(img);
            }
            if (backImgEl) {
                const img = document.createElement('img');
                img.src = backImgEl.src;
                img.style.cssText = 'width:100%;height:auto;border-radius:16px;display:block;';
                wrap.appendChild(img);
            }

            section.appendChild(wrap);
            printPage.appendChild(section);
        });

        // --- Flyers: composite via composeCanvas() so real card pixels are included ---
        for (const [key, ref] of [['flyer1', this.flyer1Ref], ['flyer2', this.flyer2Ref]]) {
            try {
                const composite = ref.current ? await ref.current.composeCanvas() : null;
                if (composite) {
                    const section = document.createElement('div');
                    section.style.cssText = 'page-break-after: always; padding: 30px 0; text-align: center;';
                    const img = document.createElement('img');
                    img.src = composite.toDataURL('image/png');
                    img.style.cssText = 'width:100%;max-width:700px;height:auto;display:inline-block;';
                    section.appendChild(img);
                    printPage.appendChild(section);
                }
            } catch (e) {
                console.error('Flyer printAll error:', key, e);
            }
        }

        document.body.innerHTML = printPage.outerHTML;
        setTimeout(() => {
            window.print();
            window.location.reload();
        }, 500);
    }
    async downloaddocall(event) {
        // Helper: draw <img> element onto a canvas and return its data URL (JPEG)
        const imgToData = (imgEl) => {
            const c = document.createElement('canvas');
            c.width = imgEl.naturalWidth || imgEl.width || 772;
            c.height = imgEl.naturalHeight || imgEl.height || 454;
            const ctx = c.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, c.width, c.height);
            ctx.drawImage(imgEl, 0, 0);
            return c.toDataURL('image/jpeg', 0.95);
        };

        // Helper: apply rounded corners to a data URL (JPEG output for jspdf compatibility)
        const applyRounded = (dataUrl) => new Promise((resolve) => {
            const tmp = new Image();
            tmp.onload = () => {
                const c = document.createElement('canvas');
                c.width = tmp.width; c.height = tmp.height;
                const ctx = c.getContext('2d');
                const r = Math.round(tmp.width * 0.033);
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, c.width, c.height);
                ctx.beginPath();
                ctx.moveTo(r, 0); ctx.lineTo(c.width - r, 0); ctx.quadraticCurveTo(c.width, 0, c.width, r);
                ctx.lineTo(c.width, c.height - r); ctx.quadraticCurveTo(c.width, c.height, c.width - r, c.height);
                ctx.lineTo(r, c.height); ctx.quadraticCurveTo(0, c.height, 0, c.height - r);
                ctx.lineTo(0, r); ctx.quadraticCurveTo(0, 0, r, 0);
                ctx.closePath(); ctx.clip();
                ctx.drawImage(tmp, 0, 0);
                resolve(c.toDataURL('image/jpeg', 0.95));
            };
            tmp.src = dataUrl;
        });

        // Helper: load a src into an Image element and resolve with it
        const loadImg = (src) => new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = src;
        });

        // --- Card sections: front + back on a SINGLE page, stacked, centred, with rounded corners ---
        const cardEls = document.querySelectorAll('.contentarea .content_sec .card_page_content .cards');
        const cardPromises = Array.from(cardEls).map((cardEl) => new Promise(async (resolve) => {
            const key = cardEl.getAttribute('id') || 'card';
            const frontCanvas = cardEl.querySelector('canvas');
            const backImgEl = cardEl.querySelector('img');

            const doc = new jsPDF('p', 'mm', 'a4');
            const pdfW = doc.internal.pageSize.getWidth();
            const CARD_W = 160; // mm — matches single-card download
            const x = (pdfW - CARD_W) / 2;
            let y = 15;
            const GAP = 6; // mm gap between front and back

            if (frontCanvas) {
                const frontData = await applyRounded(frontCanvas.toDataURL('image/png'));
                const frontH = CARD_W / (frontCanvas.width / frontCanvas.height);
                doc.addImage(frontData, 'JPEG', x, y, CARD_W, frontH);
                y += frontH + GAP;
            }

            if (backImgEl) {
                try {
                    const backData = await applyRounded(imgToData(backImgEl));
                    const backW = backImgEl.naturalWidth || backImgEl.width || 772;
                    const backH_px = backImgEl.naturalHeight || backImgEl.height || 454;
                    const backH = CARD_W / (backW / backH_px);
                    doc.addImage(backData, 'JPEG', x, y, CARD_W, backH);
                } catch (e) {
                    // fallback: add without rounded corners
                    try {
                        const backData = imgToData(backImgEl);
                        const backW = backImgEl.naturalWidth || backImgEl.width || 772;
                        const backH_px = backImgEl.naturalHeight || backImgEl.height || 454;
                        const backH = CARD_W / (backW / backH_px);
                        doc.addImage(backData, 'JPEG', x, y, CARD_W, backH);
                    } catch (e2) { /* skip */ }
                }
            }

            doc.save(key + '.pdf');
            resolve();
        }));

        // --- Flyers: use composeCanvas() via refs (FlyerLeft/FlyerRight base + real card pixels) ---
        $('.flyers').css('display', 'none');
        $('.buttons').hide();
        $('.printFlyers').css('display', 'block');
        $('.printFlyers').addClass('is-downloading');

        // Wait one frame so printFlyers has fully painted before measuring card positions
        const flyerPromises = await new Promise((resolveAll) => {
            requestAnimationFrame(() => {
                const flyerRefMap = { flyer1: this.flyer1Ref, flyer2: this.flyer2Ref };
                const promises = ['flyer1', 'flyer2'].map((key) => new Promise(async (resolve) => {
                    try {
                        const ref = flyerRefMap[key];
                        const composite = ref.current ? await ref.current.composeCanvas() : null;
                        if (composite) {
                            const pdf  = new jsPDF('p', 'mm', 'a4');
                            const pdfW = pdf.internal.pageSize.getWidth();
                            const pdfH = pdf.internal.pageSize.getHeight();
                            const ratio = Math.min((pdfW - 20) / composite.width, (pdfH - 20) / composite.height);
                            const w = composite.width  * ratio;
                            const h = composite.height * ratio;
                            // flyer2: shift 5mm right, place 10mm from top
                            const x = key === 'flyer2' ? (pdfW - w) / 2 + 5 : (pdfW - w) / 2;
                            const y = key === 'flyer2' ? 10                  : (pdfH - h) / 2;
                            pdf.addImage(composite.toDataURL('image/jpeg', 0.95), 'JPEG', x, y, w, h);
                            pdf.save(key + '.pdf');
                        }
                    } catch (e) {
                        console.error('Flyer download error:', e);
                    }
                            resolve();
                }));
                resolveAll(promises);
                });
        });

        // Reset UI once all downloads finish
        Promise.all([...cardPromises, ...flyerPromises])
            .finally(() => {
                $('.printFlyers').css('display', 'none');
                $('.flyers').css('display', 'flex');
                $('.buttons').show();
            });

        [pdf1, pdf2, pdf3].forEach((pdfUrl, index) => {
            setTimeout(() => {
                this.handleDownload(pdfUrl);
            }, index * 500);
        });
    }

    GetUserGroups(UserId, UserName) {
        userService.GetUserGroups(UserId, UserName)
            .then(apidata => {
                this.setState(
                    {
                        group_numbers: apidata,
                        selected_group: apidata[0].groupnumber,
                        group_status: apidata[0].status,
                        isPrimary: apidata[0].isPrimary
                    },
                    () => {
                        // group_numbers is now in state — safe to filter
                        this.selectedGroupData(apidata[0].groupnumber);
                        const cardsData = this.getCardsData();
                        this.setState({ cardsData });
                    }
                );
            });
    }


    async updateGroup(e) {
        let group_no = e.target.value
        await this.selectedGroupData(group_no)
        this.setState({ selected_group: group_no })
    }
    selectedGroupData(seldata) {
        let sgd = this.state.group_numbers.filter((item) => {
            return item.groupnumber === seldata ? item : null
        })
        this.setState({ GroupData: sgd[0], isPrimary: sgd[0].isPrimary })
    }
    printIndivisual(event, id) {
        if (id === 'flyer1' || id === 'flyer2') {
            $('.printFlyers').css({ display: 'block' });
            $('.printFlyers').addClass('is-printing');

            requestAnimationFrame(async () => {
                try {
                    const flyerRef = id === 'flyer1' ? this.flyer1Ref : this.flyer2Ref;
                    const composite = flyerRef.current ? await flyerRef.current.composeCanvas() : null;
                    if (composite) {
                        const imgSrc = composite.toDataURL('image/png');
                        document.body.innerHTML = `<div style="text-align:center;padding:20px;"><img src="${imgSrc}" style="max-width:700px;width:100%;height:auto;display:inline-block;" /></div>`;
                    }
                } finally {
                    setTimeout(() => {
                        window.print();
                        window.location.reload();
                    }, 500);
                }
            });
            return;
        } else {
            // .print → .buttons → .header → nextSibling (.order_card_wrapper with id)
            const cardEl = document.getElementById(event.target.parentElement.parentElement.nextElementSibling.getAttribute('id'));
            if (!cardEl) return;
            const frontCanvas = cardEl.querySelector('canvas');
            const backImgEl = cardEl.querySelector('img');

            // Build a print-ready wrapper — 700px wide, centred, cards fill full width
            const printWrap = document.createElement('div');
            printWrap.style.cssText = 'display:flex;flex-direction:column;gap:24px;width:700px;max-width:100%;margin:30px auto;';

            if (frontCanvas) {
                const frontImg = document.createElement('img');
                frontImg.src = frontCanvas.toDataURL('image/png');
                frontImg.style.cssText = 'width:100%;height:auto;border-radius:16px;display:block;';
                printWrap.appendChild(frontImg);
            }
            if (backImgEl) {
                const backClone = document.createElement('img');
                backClone.src = backImgEl.src;
                backClone.style.cssText = 'width:100%;height:auto;border-radius:16px;display:block;';
                printWrap.appendChild(backClone);
            }

            document.body.innerHTML = printWrap.outerHTML;
        }
        setTimeout(() => {
            window.print();
            window.location.reload()
        }, 500)
    }
    downloaddoc(id, name, event) {
        if (id === 'flyer1' || id === 'flyer2') {
            // Show the printFlyers section so the FlyerPage component is in the DOM and rendered
            $('.buttons').hide();
            $('.printFlyers').css({ display: 'block' });
            $('.printFlyers').addClass('is-downloading');

            // Give the DOM one frame to paint the flyer image + cards
            requestAnimationFrame(async () => {
                try {
                    const flyerRef = id === 'flyer1' ? this.flyer1Ref : this.flyer2Ref;
                    const composite = flyerRef.current ? await flyerRef.current.composeCanvas() : null;

                    if (composite) {
                        const doc  = new jsPDF('p', 'mm', 'a4');
                        const pdfW = doc.internal.pageSize.getWidth();
                        const pdfH = doc.internal.pageSize.getHeight();
                        const ratio = Math.min((pdfW - 20) / composite.width, (pdfH - 20) / composite.height);
                        const w = composite.width  * ratio;
                        const h = composite.height * ratio;
                        doc.addImage(composite.toDataURL('image/jpeg', 0.95), 'JPEG', (pdfW - w) / 2, (pdfH - h) / 2, w, h);
                        doc.save(id + '.pdf');
                    }
                } finally {
                    $('.buttons').show();
                    $('.printFlyers').css({ display: 'none' });
                    $('.printFlyers').removeClass('is-downloading');
                }
            });
            return;
                        } else {
            // Canvas-based cards: use canvas.toDataURL() directly (domtoimage can't read canvas pixels)
            const cardEl = document.getElementById(id);
            if (!cardEl) return;
            const frontCanvas = cardEl.querySelector('canvas');
            const backImgEl = cardEl.querySelector('img');

            const applyRounded = (dataUrl) => new Promise((resolve) => {
                const tmp = new Image();
                tmp.onload = () => {
                    const c = document.createElement('canvas');
                    c.width = tmp.width; c.height = tmp.height;
                    const ctx = c.getContext('2d');
                    const r = Math.round(tmp.width * 0.033);
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(0, 0, c.width, c.height);
                    ctx.beginPath();
                    ctx.moveTo(r, 0); ctx.lineTo(c.width - r, 0); ctx.quadraticCurveTo(c.width, 0, c.width, r);
                    ctx.lineTo(c.width, c.height - r); ctx.quadraticCurveTo(c.width, c.height, c.width - r, c.height);
                    ctx.lineTo(r, c.height); ctx.quadraticCurveTo(0, c.height, 0, c.height - r);
                    ctx.lineTo(0, r); ctx.quadraticCurveTo(0, 0, r, 0);
                    ctx.closePath(); ctx.clip();
                    ctx.drawImage(tmp, 0, 0);
                    resolve(c.toDataURL('image/jpeg', 0.95));
                };
                tmp.src = dataUrl;
            });
            const getAspect = (el) => {
                if (!el) return 772 / 454;
                const w = el.tagName === 'CANVAS' ? el.width : (el.naturalWidth || el.width);
                const h = el.tagName === 'CANVAS' ? el.height : (el.naturalHeight || el.height);
                return (w > 0 && h > 0) ? w / h : 772 / 454;
            };
            const imgToData = (imgEl) => {
                const c = document.createElement('canvas');
                c.width = imgEl.naturalWidth || imgEl.width;
                c.height = imgEl.naturalHeight || imgEl.height;
                const ctx = c.getContext('2d');
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, c.width, c.height);
                ctx.drawImage(imgEl, 0, 0);
                return c.toDataURL('image/jpeg', 0.95);
            };

            (async () => {
                const doc = new jsPDF('p', 'mm', 'a4');
                const pdfW = doc.internal.pageSize.getWidth();
                const pdfH = doc.internal.pageSize.getHeight();
                const margin = 15;
                const CARD_W = 160;
                const x = (pdfW - CARD_W) / 2;
                let y = margin;

                if (frontCanvas) {
                    const frontData = await applyRounded(frontCanvas.toDataURL('image/png'));
                    const frontH = CARD_W / getAspect(frontCanvas);
                    doc.addImage(frontData, 'JPEG', x, y, CARD_W, frontH);
                    y += frontH + 8;
                }
                if (backImgEl) {
                    try {
                        const backData = await applyRounded(imgToData(backImgEl));
                        const backH = CARD_W / getAspect(backImgEl);
                        if (y + backH <= pdfH - margin) {
                            doc.addImage(backData, 'JPEG', x, y, CARD_W, backH);
        } else {
                            doc.addPage();
                            doc.addImage(backData, 'JPEG', x, margin, CARD_W, backH);
                        }
                    } catch (e) {
                        const backH = CARD_W / getAspect(backImgEl);
                        doc.addImage(imgToData(backImgEl), 'JPEG', x, y, CARD_W, backH);
                    }
                    }
                    doc.save(name + '.pdf');
            })();
        }
    }
    GetUserCardSetting(UserId, UserName) {
        this.setState({ loader: true })
        try {
            userService.UserSetting(UserName, UserId)
                .then(
                    apidata => {
                        if (apidata.length > 0) {
                            if (apidata[0].code !== '-1') {
                                this.setState({ SuccessMessage: false, loader: false, cardSetting: apidata[0].cardSetting });
                            } else {
                                this.setState({ SuccessMessage: false, loader: false, errorMsg: apidata[0].message });
                            }
                        }
                    }
                );
        }
        catch (error) {
            this.setState({ loader: false })
        }
    }
    handleOutsideClick = (event) => {
        if (event.target.classList.contains("zoomed-flyer") && !event.target.closest('#flyer1') && !event.target.closest('#flyer2')) {
            if (this.state.zoomLeft || this.state.zoomRight) {
                this.setState({ zoomLeft: false, zoomRight: false });
            }
        }
    };

    handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            this.setState({ zoomLeft: false, zoomRight: false });
        }
    };
    getCardsData = () => {
        const userRole = window.atob(localStorage.getItem('UserRole'));
        const { group_status } = this.state;
        let cardsData = [{
            cardname: 'Glic Card',
            classnames: 'glic_card',
            bin: '023518',
            pcn: 'ARX',
        }];

        if (group_status === 'Yes') {
            cardsData.push(
                {
                    cardname: 'Citizen Card',
                    classnames: 'citizen_card',
                    bin: '015284',
                    pcn: 'CRX'
                },
                {
                    cardname: 'NVT Card',
                    classnames: 'nvt_card',
                    bin: '610602',
                    pcn: 'NVT'
                },
                {
                    cardname: 'CVS Card',
                    classnames: 'cvs_card',
                    bin: '610398',
                    pcn: 'CV1'
                },
                {
                    cardname: 'DST Card',
                    classnames: 'dst_card',
                    bin: '600428',
                    pcn: 'HRX'
                }
            );
        }

        return cardsData.map((card) => {
            let datetime = Math.floor(Math.random() * 1313131);
            let mId = (card.classnames === 'cvs_card' || card.classnames === 'walmart_card')
                ? `AX${datetime}`
                : userRole === 'consumer'
                    ? '100-4542'
                    : `AX${datetime}`;

            return { ...card, mId };
        });
    };
    handlePrint = (pdfKey) => {
        if (this.iframeRefs[pdfKey].current) {
            this.iframeRefs[pdfKey].current.contentWindow.focus();
            this.iframeRefs[pdfKey].current.contentWindow.print();
        }
    }
    handleDownload = (pdfUrl) => {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = pdfUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    getPricingSheets(UserId) {
        try {
            userService.FetchPricingSheets(UserId).then((apiData) => {
                if (apiData && apiData.length > 0) {
                    this.setState({ pricingSheetData: apiData });
                }
            })
        } catch (err) {
        }
    }
    render() {
        let { group_numbers } = this.state;
        let userRole = window.atob(localStorage.getItem('UserRole'));
        let cardsData = [
            {
                cardname: 'Glic Card',
                classnames: 'glic_card',
                bin: '023518',
                pcn: 'ARX',
            }];
        if (this.state.group_status === 'Yes') {
            cardsData = [{
                cardname: 'Glic Card',
                classnames: 'glic_card',
                bin: '023518',
                pcn: 'ARX',
            },
            {
                cardname: 'Citizen Card',
                classnames: 'citizen_card',
                bin: '015284',
                pcn: 'CRX'
            },
            //{
            //    cardname: 'Walmart Card',
            //    classnames: 'walmart_card',
            //    bin: '610396',
            //    pcn: 'WM1'
            //},
            {
                cardname: 'NVT Card',
                classnames: 'nvt_card',
                bin: '610602',
                pcn: 'NVT'
            },
            {
                cardname: 'CVS Card',
                classnames: 'cvs_card',
                bin: '610398',
                pcn: 'CV1'
            },
            {
                cardname: 'DST Card',
                classnames: 'dst_card',
                bin: '600428',
                pcn: 'HRX'
            }];
        }
        if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) === true) return <Redirect to="/signup" />
        /* if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) != true && this.state.account_info != 0) return <Redirect to="/account" />*/
        localStorage.setItem('pagename', 'ordercard');

        return (window.atob(localStorage.getItem('UserRole')) == "Distributor" ?
            <div>
                {
                    (this.state.selected_group === null || this.state.selected_group === "" || this.state.selected_group === undefined) ?
                        null :
                        <div className="Dashboard_Area">
                            <Left_Sidebar Activemenu="4" account_info={this.state.account_info} fullName={this.state.fullName} />
                            <div className="contentarea">
                                <Header shortName={this.state.shortname} fullName={this.state.fullName} userRole="" />
                                <div className="content_sec">
                                    <div className="Card_Page_header">
                                        <div className="h2_title">
                                            <h2>Marketing Materials</h2>
                                            <p>The assets below are your personal cards and flyers to print and share.</p>
                                        </div>
                                        <div className="buttons_area AddPayment marketing-buttons_area">
                                            <div className="button" onClick={this.downloaddocall.bind(this)}>Download All</div>
                                            <div className="button" onClick={this.printAll.bind(this)}>Print All</div>
                                            {/*<div className="button cart-button" onClick={this.handleClick.bind(this)}>Shop Now <CartIcon /></div>*/}
                                            {/*<div className="button red"><a href="https://www.rxhacker.supply/" target="_blank">Order Printed Cards</a></div>*/}
                                            {/*<div className="button red" onClick={this.handleClick.bind(this)}>Get Your Starter Kit</div>*/}
                                        </div>
                                    </div>
                                    <div className="card_page_content marketing-materials">
                                        <div className="all_cards">
                                            <div className="select_group">
                                                <select onChange={this.updateGroup} value={this.state.selected_group} className="tt_select">
                                                    {
                                                        group_numbers.map((card, index) =>
                                                            <option key={index} value={card.groupnumber}>{card.groupnumber}</option>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                            {
                                                this.state.cardsData ? this.state.cardsData.map((card, index) => {
                                                    /*let mId;
                                                    let datetime = Math.floor(Math.random() * 1313131);
                                                    let userGroup = this.state.GroupData.groupnumber;
                                                    if (card && card.classnames === 'cvs_card') {
                                                        mId = "AX" + datetime;
                                                    } else if (card && card.classnames === 'walmart_card') {
                                                        mId = "AX" + datetime;
                                                    } else {
                                                        mId = userRole === 'consumer' ? '100-4542' : "AX" + datetime;
                                                    }
                                                    card.mId = mId;*/
                                                    return (
                                                        <div key={index} className="card">
                                                            <div className="header">
                                                            <h3>{card.cardname}</h3>
                                                            <div className="buttons">
                                                                <div className="download" onClick={this.downloaddoc.bind(this, card.pcn + "_" + this.state.GroupData.groupnumber + index, card.pcn + "_" + this.state.GroupData.groupnumber)}></div>
                                                                <div className="print" onClick={this.printIndivisual.bind(this)}></div>
                                                            </div>
                                                            </div>
                                                            <div className={'order_card_wrapper cards ' + card.classnames} id={card.pcn + "_" + this.state.GroupData.groupnumber + index}>
                                                                <CardFront cardData={card} groupData={this.state.GroupData} />
                                                                <CardBack cardData={card} mId={card.mId} groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} />
                                                            </div>
                                                            <div className={cardsData.length - 1 === index ? 'pagebreak hide' : 'pagebreak'}> </div>
                                                        </div>
                                                    )
                                                }) : null
                                            }
                                            <div className="nonPrintable"><h3 style={{ marginBottom: '10px' }}>Printable Flyers</h3></div>
                                            <div className="flyers">
                                                <div className="flyerPage">
                                                    <div className="buttons">
                                                        <div className="download" onClick={this.downloaddoc.bind(this, 'flyer2')}></div>
                                                        <div className="print" onClick={this.printIndivisual.bind(this, '', 'flyer2')}></div>
                                                    </div>
                                                    <div className="flyerBox" onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.setState({ zoomRight: true });
                                                    }}>
                                                        <img src={FlyerRight} />
                                                    </div>
                                                    {this.state.zoomRight ? <div className="zoomed-flyer" onClick={() => this.setState({ zoomRight: false })}>
                                                        <div className="zoomed-flyer-inner" onClick={e => e.stopPropagation()}>
                                                        <div className="close" onClick={() => this.setState({ zoomRight: false })}>
                                                            <img src={closeIcon} alt="Close" />
                                                        </div>
                                                        <FlyerPage2 bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                                        </div>
                                                    </div> : null}
                                                </div>
                                                <div className="flyerPage">
                                                    <div className="buttons">
                                                        <div className="download" onClick={this.downloaddoc.bind(this, 'flyer1')}></div>
                                                        <div className="print" onClick={this.printIndivisual.bind(this, '', 'flyer1')}></div>
                                                    </div>
                                                    <div className="flyerBox" onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.setState({ zoomLeft: true });
                                                    }}>
                                                        <img src={FlyerLeft} />
                                                    </div>
                                                    {this.state.zoomLeft ? <div className="zoomed-flyer" onClick={() => this.setState({ zoomLeft: false })}>
                                                        <div className="zoomed-flyer-inner" onClick={e => e.stopPropagation()}>
                                                        <div className="close" onClick={() => this.setState({ zoomLeft: false })}>
                                                            <img src={closeIcon} alt="Close" />
                                                        </div>
                                                        <FlyerPage1 bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                                        </div>
                                                    </div> : null}
                                                </div>
                                            </div>
                                            <div className="nonPrintable"><h3 style={{ marginBottom: '10px' }}>Pricing Sheets</h3></div>
                                            <div className="pricing-sheets">
                                                {/* PDF 1 */}
                                                {this.state.pricingSheetData && this.state.pricingSheetData.length ? this.state.pricingSheetData.map((item, index) => <>
                                                    <div className="buttons">
                                                        <div className="download" onClick={() => this.handleDownload(item.filePath)}></div>
                                                        <div className="print" onClick={() => this.handlePrint(`pdf${index + 1}`)}></div>
                                                    </div>
                                                    <div className="sheet" onClick={() => window.open(item.filePath, "_blank", "noopener,noreferrer")}>
                                                        <iframe
                                                            ref={this.iframeRefs[`pdf${index + 1}`]}
                                                            src={item.filePath + "#toolbar=0&navpanes=0&scrollbar=0"}
                                                            width="100%"
                                                            height="300px"
                                                            title={item.fileName}
                                                        />
                                                    </div>
                                                </>) : null}

                                                {/* PDF 2 
                                                <div className="buttons">
                                                    <div className="download" onClick={() => this.handleDownload(pdf2)}></div>
                                                    <div className="print" onClick={() => this.handlePrint("pdf2")}></div>
                                                </div>
                                                <div className="sheet" onClick={() => window.open(pdf2, "_blank", "noopener,noreferrer")}>
                                                    <iframe
                                                        ref={this.iframeRefs.pdf2}
                                                        src={pdf2 + "#toolbar=0&navpanes=0&scrollbar=0"}
                                                        width="100%"
                                                        height="300px"
                                                        title="NuLifeSpan Top CVS Mar25"
                                                    />
                                                </div>*/}

                                                {/* PDF 3 
                                                <div className="buttons">
                                                    <div className="download" onClick={() => this.handleDownload(pdf3)}></div>
                                                    <div className="print" onClick={() => this.handlePrint("pdf3")}></div>
                                                </div>
                                                <div className="sheet" onClick={() => window.open(pdf3, "_blank", "noopener,noreferrer")}>
                                                    <iframe
                                                        ref={this.iframeRefs.pdf3}
                                                        src={pdf3 + "#toolbar=0&navpanes=0&scrollbar=0"}
                                                        width="100%"
                                                        height="300px"
                                                        title="NuLifeSpan Walmart top Mar25"
                                                    />
                                                </div>*/}
                                            </div>
                                            <div className="printFlyers" style={{ display: "none" }}>
                                                <div className="page-break"></div>
                                                <FlyerPage1 ref={this.flyer1Ref} bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                                <div className="page-break"></div>
                                                <FlyerPage2 ref={this.flyer2Ref} bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="card_page_content">
                                    {group_numbers.map((card, index) =>
                                        <CardPartial key={index}  {...card}/>
                                    )}
                                </div>*/}
                                    <div>
                                        <div className="Account_info_form_parent order_cards_form">
                                            {this.state.show_Payment_popup === true ? (
                                                <div className="resetgroup_box">
                                                    <OrderPage toggle_user_detail={this.toggle_user_detail.bind(this)} forCard={true} groupNumbers={group_numbers} />
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                }
            </div> : <Redirect to="/page-not-found" />
        );
    }
}
export default OrderCardsPage;